<script setup lang="ts">
import type { EventExpense } from '@@/types/api';
import { formatCurrency } from '~/composables/format-currency';

defineProps<{
  expenses: EventExpense[];
}>();
</script>

<template>
  <div class="event-expenses-section mb-6">
    <h2 class="text-h6 mb-3">How funds will be used</h2>

    <v-list density="compact" class="bg-transparent">
      <v-list-item v-for="expense in expenses" :key="expense.id">
        <template #prepend>
          <v-icon size="small" color="primary">mdi-circle-small</v-icon>
        </template>
        <v-list-item-title>
          {{ expense.label }}
          <span class="font-weight-bold ml-2">
            {{ formatCurrency(expense.amount) }}
          </span>
        </v-list-item-title>
        <v-list-item-subtitle v-if="expense.note">
          {{ expense.note }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </div>
</template>
